// Variables related with emailJS
const emailConfig = {
  serviceName: process.env.REACT_APP_EMAILJS_SERVICE_NAME,
  templateName: process.env.REACT_APP_EMAILJS_TEMPLATE_NAME,
  emailApiKey: process.env.REACT_APP_EMAILJS_API_KEY,
}

export default emailConfig;